import { render, staticRenderFns } from "./TableDataselection.vue?vue&type=template&id=1b15e478&"
import script from "./TableDataselection.vue?vue&type=script&lang=js&"
export * from "./TableDataselection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports